export default __webpack_public_path__ + "static/characters_07_Ivy_Iron0-fafbb4bafd94932b1da6a77a9ca6efac.png";